type VariantWithBnplPrice = {
  calculated_price?: {
    calculated_amount: number;
    currency_code: string;
  } | null;
};

type ProductWithBnplVariants = {
  variants?: VariantWithBnplPrice[] | null;
};

export const BNPL_MIN_AMOUNT = 50;

function getEligiblePrice(
  variant: VariantWithBnplPrice | undefined,
): { amount: number; currencyCode: string } | null {
  const cp = variant?.calculated_price;
  if (!cp || cp.calculated_amount < BNPL_MIN_AMOUNT) return null;
  return { amount: cp.calculated_amount, currencyCode: cp.currency_code };
}

export function findEligiblePrice(
  product: ProductWithBnplVariants,
  selectedVariant?: VariantWithBnplPrice,
): { amount: number; currencyCode: string } | null {
  const selectedPrice = getEligiblePrice(selectedVariant);
  if (selectedPrice) return selectedPrice;

  const eligible = (product.variants ?? [])
    .map((v) => getEligiblePrice(v))
    .filter((p): p is NonNullable<typeof p> => p !== null)
    .sort((a, b) => a.amount - b.amount);

  return eligible[0] ?? null;
}
